(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mse-beauty-product-selector"] && !Shopify.designMode) return;
  try {
    
  class MseBeautySelector {
    constructor(root) {
      this.root = root;
      this.cards = [...root.querySelectorAll('[data-product-card]')];
      this.button = root.querySelector('[data-add-button]');
      this.form = root.querySelector('[data-add-form]');
      this.error = root.querySelector('[data-error]');
      this.total = root.querySelector('[data-total]');
      this.currency = document.documentElement.lang || 'en';
      this.bindEvents();
      this.update();
    }
    bindEvents() {
      this.root.addEventListener('change', (event) => {
        const card = event.target.closest('[data-product-card]');
        if (card && event.target.matches('[data-include-item]')) {
          card.classList.toggle('is-excluded', !event.target.checked);
          card.querySelectorAll('select, input[type="number"]').forEach((field) => { field.disabled = !event.target.checked; });
        }
        this.update();
      });
      this.root.addEventListener('input', () => this.update());
      if (this.form) {
        this.form.addEventListener('submit', (event) => { event.preventDefault(); this.addSelectedItems(); });
      } else if (this.button) {
        this.button.addEventListener('click', () => this.addSelectedItems());
      }
    }
    selectedItems() {
      return this.cards.flatMap((card) => {
        const include = card.querySelector('[data-include-item]');
        const select = card.querySelector('[data-variant-select]');
        const quantity = card.querySelector('[data-quantity]');
        if (!include.checked || !select.value || select.selectedOptions[0]?.disabled) return [];
        return [{ id: Number(select.value), quantity: Math.max(1, Math.min(10, Number(quantity.value) || 1)) }];
      });
    }
    update() {
      let cents = 0;
      this.cards.forEach((card) => {
        const include = card.querySelector('[data-include-item]');
        if (!include.checked) return;
        const option = card.querySelector('[data-variant-select]').selectedOptions[0];
        const qty = Math.max(1, Math.min(10, Number(card.querySelector('[data-quantity]').value) || 1));
        cents += (Number(option?.dataset.price) || 0) * qty;
      });
      const shopCurrency = window.Shopify?.currency?.active || 'EUR';
      this.total.textContent = new Intl.NumberFormat(this.currency, { style: 'currency', currency: shopCurrency }).format(cents / 100);
    }
    showError(message) { this.error.textContent = message; this.error.hidden = false; }
    addSelectedItems() {
      this.error.hidden = true;
      const bundleCard = this.cards[2];
      const scrubCard  = this.cards[0];
      const candleCard = this.cards[1];
      if (!bundleCard) { this.showError('Bundle product is not configured.'); return; }
      const bundleSelect = bundleCard.querySelector('[data-variant-select]');
      const bundleVariantId = bundleSelect ? bundleSelect.value : '';
      if (!bundleVariantId || bundleSelect.selectedOptions[0]?.disabled) { this.showError('Please select a bundle option.'); return; }
      let scrubLabel = '';
      if (scrubCard) { const si = scrubCard.querySelector('[data-include-item]'); const ss = scrubCard.querySelector('[data-variant-select]'); if (si?.checked && ss) scrubLabel = ss.selectedOptions[0]?.text || ''; }
      let candleLabel = '';
      if (candleCard) { const ci = candleCard.querySelector('[data-include-item]'); const cs = candleCard.querySelector('[data-variant-select]'); if (ci?.checked && cs) candleLabel = cs.selectedOptions[0]?.text || ''; }
      const bundleLabel = bundleSelect.selectedOptions[0]?.text || '';
      const formId     = this.form.querySelector('[data-form-id]');
      const formBundle = this.form.querySelector('[data-form-bundle]');
      const formScrub  = this.form.querySelector('[data-form-scrub]');
      const formCandle = this.form.querySelector('[data-form-candle]');
      if (formId)     formId.value     = bundleVariantId;
      if (formBundle) formBundle.value = bundleLabel;
      if (formScrub)  formScrub.value  = scrubLabel;
      if (formCandle) formCandle.value = candleLabel;
      this.button.click();
    }
  }
  const initMseBeautySelectors = (scope = document) => {
    scope.querySelectorAll('.mse-beauty-selector:not([data-initialized])').forEach((root) => {
      root.dataset.initialized = 'true';
      new MseBeautySelector(root);
    });
  };
  initMseBeautySelectors();
  document.addEventListener('shopify:section:load', (event) => initMseBeautySelectors(event.target));

  } catch(e) { console.error(e); }
})();
})();
